import styled, { css } from 'styled-components'

import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'

const baseFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const NetworkAlertsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
`

export const NetworkAlertsHeader = styled.div`
  ${baseFlex};
  justify-content: space-between;
`

export const VisitMistButton = styled(CommonButton)`
  text-transform: capitalize;
  font-weight: 900;
  min-height: 40px;
  border-radius: 8px;
  background: transparent;
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.s} ${theme.spacing.lg};
  }
  && {
    appearance: none;
  }
`
